import { render, staticRenderFns } from "./ServeShipper.vue?vue&type=template&id=72bb3fba&scoped=true&"
import script from "./ServeShipper.vue?vue&type=script&lang=js&"
export * from "./ServeShipper.vue?vue&type=script&lang=js&"
import style0 from "./ServeShipper.vue?vue&type=style&index=0&id=72bb3fba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb3fba",
  null
  
)

export default component.exports